<template>
    <div>
        <CHeading>Prečo je stáž tá správna voľba?</CHeading>

        <img
            alt="Stáže pre študentov na GROWNi.sk"
            class="mb-8"
            loading="lazy"
            src="https://growni.sk/images/blog/staze-pre-studentov-na-growni.png"
            title="Stáže pre študentov na GROWNi.sk"
        />

        <p>
            Pozná to hádam každý z nás, sedíš doma na gauči, prichádza leto, všetci tvoji kamaráti sú rozutekaní
            kade-tade a&nbsp;ty rozmýšľaš, čo robiť počas tohto obdobia. Určite si chceš privyrobiť, a&nbsp;tak sa
            trošku finančne osamostatniť, zároveň chceš svoje leto využiť naplno a&nbsp;nenudiť sa. Veľa z&nbsp;nás
            začínalo svoju kariérnu cestu tak, že si počas leta našlo popri strednej či vysokej škole pár brigád. Na tom
            samozrejme nie je nič zlé, čo ak by sa to ale dalo aj inak? Čo takto získať stáž, vďaka ktorej získaš nové
            vedomosti a&nbsp;skúsenosti a&nbsp;posunieš sa vpred osobnostne i&nbsp;pracovne.
        </p>

        <p>
            Asi viem čo ti teraz behá hlavou „takýto typ práce si ma predsa počká", „naplno sa venujem škole, tak si
            chcem aspoň v&nbsp;lete oddýchnuť" alebo „nebudem vymýšľať, veď aj tak nemám skúsenosti, ani vedomosti na
            to, aby som sa na podobnú prácu dal." Ak spadáš do tejto skupiny a&nbsp;práve tieto myšlienky sa ti
            vynorili, tak na ne rýchlo zabudni a&nbsp;skús sa spýtať samého seba radšej nejako takto „prečo by som mal
            svoje leto venovať práve stáži?", &nbsp;„čo mi to prinesie?" a „aký to bude mať pre mňa význam?"
        </p>

        <p>My ti prinášame odpovede práve na tieto otázky...</p>

        <CHeading variant="2">Čo ti teda vie stáž priniesť?</CHeading>

        <p>
            Okrem vyplnenia leta, ti samozrejme poskytne cenné pracovné skúsenosti. Nielen, že sa nudiť rozhodne
            nebudeš, ale naštartuješ aj svoju profesijnú dráhu. Stáž počas školy tiež skrášli tvoj životopis a cesta k
            budúcim pracovným príležitostiam tak bude jednoduchšia. Pre viaceré organizácie či firmy je dôležité, že
            daný človek už za sebou isté skúsenosti má a vedel sa popri už škole venovať aj iným aktivitám. Je to dôkaz
            toho, že vie riadiť svoj čas, chce sa zlepšovať a nabrať skúsenosti, čo si každý zamestnávateľ cení.
        </p>

        <CHeading variant="2">Je teraz vôbec vhodná situácia na hľadanie si stáže?</CHeading>

        <p>
            Rozhodne áno. Samozrejme, je pravda, že viaceré organizácie museli skresávať svoje rozpočty, či prepúšťať
            zamestnancov. Stále sa však nájde množstvo takých, ktorí práve v&nbsp;tomto období ocenia inšpiratívne
            a&nbsp;jedinečné nápady, ktoré mladí ľudia vedia priniesť. Množstvo organizácií sa presunulo do online módu,
            máš teda jedinečnú príležitosť pracovať vo firme mimo svojho mesta, či kraja. Zároveň je to skvelá možnosť,
            ako v&nbsp;momentálnej situácii pomôcť firmám, organizáciám či verejnej správe a&nbsp;priniesť do týchto
            kruhov nový vietor. Tak hor sa do toho, naber trochu odvahy a&nbsp;siahni po svojej vysnívanej stáži.
        </p>

        <p>A&nbsp;teraz keď ťa naplnilo odhodlanie sa&nbsp;vrhneme na tú najzákladnejšiu otázku..</p>

        <CHeading variant="2">Ako si nájsť tú správnu stáž?</CHeading>

        <p>
            Najskôr si treba rozmyslieť v&nbsp;akom obore by ťa stáž zaujímala. Ak ti v&nbsp;tomto momente napadlo
            odvetvie akým sa chceš uberať, tak si hľadaj stáž práve v&nbsp;ňom. Nezabúdaj, že stáž vieš získať
            v&nbsp;akomkoľvek odbore, vôbec nemusí súvisieť s&nbsp;tým, čo študuješ. Povedzme, že napríklad študuješ
            financie, no už veľmi dlho ťa fascinujú kreatívne reklamy, pokojne sa teda môžeš rozhodnúť stážovať
            v&nbsp;reklamnej agentúre. Najdôležitejšie je zamyslieť sa nad tým, čo ťa baví a&nbsp;napĺňa. Ak naopak
            tápaš , skús i niečo, nad čím si doteraz nerozmýšľal a&nbsp;hor sa do toho. Sprav si podrobný prieskum ponúk
            a zamysli sa nad svojimi silnými stránkami a&nbsp;zručnosťami, ktoré na budeš na danú prácu potrebovať.
            Vytvor si kvalitný životopis, ktorý bude odrážať všetky tvoje pracovné i&nbsp;nepracovné skúsenosti. Potom
            sa stačí už len prihlásiť!
        </p>

        <p>
            Pri definovaní tvojich silných stránok ti vedia dopomôcť rôzne personálne testy osobnosti ako napríklad:
            <a class="link" href="https://www.16personalities.com/" target="_blank">https://www.16personalities.com/</a>
        </p>

        <CHeading variant="2">Prečo si hľadať príležitosť cez GROWNi?</CHeading>

        <p>
            Na našej platforme nájdeš široké množstvo ponúk, či už vo verejnom sektore, neziskovkách alebo start-upoch
            po celom Slovensku. Niektoré pozície sa dajú vykonávať aj online. S partnermi sme ich však poctivo
            dohadovali, aby mali pre teba čo najväčšiu pridanú hodnotu. Teda aby si mal priestor osobnostne a profesijne
            rásť a posúvať sa ďalej. Zároveň sú pre nás dôležité hodnoty, ktoré tieto organizácie šíria, ako napríklad
            etickosť a aby výsledok tvojej práce mal širší dopad na spoločnosť. A to nie je na zahodenie, nie? 😊
            U&nbsp;nás máš taktiež možnosť získať okrem stáží aj veľké množstvo skillov, mentoringu, či dobrovoľníckych
            príležitostí, ktoré ti pomôžu skrášliť tvoj životopis.
        </p>

        <CHeading variant="2"> Nie sú stáže iba o varení kávičiek a o lacnej pracovnej sile? </CHeading>

        <p>
            Ako sme písali vyššie, naše rozhodne nie. Chceme, aby boli so stážou či full-timom spokojné obe strany, ty
            aj partner. S pracovnými príležitosťami máme dlhoročné skúsenosti a pravidelne zbierame feedbacky, aby sme
            príležitosti vedeli stále zlepšovať. Zároveň, slúžime i ako garancia kvality – ak máš nejaké problémy, stáž
            či full-time neprebieha podľa tvojich predstáv, spoločne to určite vyriešime.
        </p>

        <CHeading variant="2">Aké ponuky na GROWNi nájdem?</CHeading>

        <p>
            Skutočne rôzne, od marketingu, IT, financií po rôzne pozície vo verejnom sektore. Napríklad u&nbsp;nás
            nájdeš zaujímavú pozíciu v&nbsp;technologickej spoločnosť Elysium Tech, ktorá do svojich radov hľadá
            marketingového a&nbsp;komunitného manažéra. Ak ťa zaujíma skôr neziskový sektor, u&nbsp;nás máš príležitosť
            nájsť stáž napríklad vo vzdelávacom a&nbsp;rozvojovom programe Nexteria.
        </p>

        <CHeading variant="2">A ako sa mám na stáž prihlásiť?</CHeading>

        <p>
            Klikaj na
            <a class="link" href="https://growni.sk/praca">https://growni.sk/praca</a>
            a vyber si tú pravú stáž pre teba😊 Držíme ti palce!
        </p>
    </div>
</template>

<script setup lang="ts">
// In Vue 3 with <script setup>, components used in the template are automatically imported
// CHeading component is auto-imported since it's used in the template
</script>